export class AppVersionEvents {
  static _instance: AppVersionEvents | undefined
  private listeners = new Set<(version: string) => void>()

  private constructor() {
    // singleton
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new AppVersionEvents()
    }
    return this._instance
  }

  emit(version: string) {
    this.listeners.forEach((listener) => listener(version))
  }

  addListener(callback: (version: string) => void) {
    this.listeners.add(callback)
  }

  removeListener(callback: (version: string) => void) {
    this.listeners.delete(callback)
  }
}
